"use strict";

var computeRoundedQuantity = require('../../../helpers/computeRoundedQuantity');
/**
 * interpolatePricePoints
 * @param {number} qplus - the quantity + extras that need to be printed
 * @param {number[]} pricePointsArray - an array of price points for booklet wedding programs
 * @returns {number} the price at or between the points
 */


function interpolatePricePoints(qplus, pricePointsArray) {
  var linePrice;
  var p1 = Math.floor((qplus - 25) / 25);
  var p2 = p1 + 1;
  var d = (qplus - 25) / 25 - Math.floor((qplus - 25) / 25); // 0, 0.2, 0.4, 0.8 etc

  if (qplus >= 250) {
    // linear interpolation from the end
    linePrice = pricePointsArray[7] + (qplus - 200) / 25 * 10;
  } else {
    // linear interpolation between price points
    linePrice = (pricePointsArray[p2] - pricePointsArray[p1]) * d + pricePointsArray[p1];
  }

  return linePrice;
}
/**
 * linePriceOnePage
 * @param {number} qplus - quantity plus extras
 * @returns {number} the price at or between the points
 */


function linePriceOnePage(qplus) {
  var linePrice = 0;

  if (qplus >= 25 && qplus < 75) {
    linePrice = 60 + 1.2 * (qplus - 25);
  } else if (qplus >= 75 && qplus < 150) {
    linePrice = 120 + 0.8 * (qplus - 75);
  } else if (qplus >= 150) {
    linePrice = 180 + 0.4 * (qplus - 150);
  }

  return linePrice;
}
/**
 * linePriceTwoPages
 * @param {number} qplus - quantity plus extras
 * @returns {number} the price at or between the points
 */


function linePriceTwoPages(qplus) {
  // these are the negotiated price points for qty 25, 50, 75, etc.
  var pricePoints = [80, 130, 170, 190, 230, 250, 270, 290, 300, 310];
  return interpolatePricePoints(qplus, pricePoints);
}
/**
 * linePriceThreePages
 * @param {number} qplus - quantity plus extras
 * @returns {number} the price at or between the points
 */


function linePriceThreePages(qplus) {
  // these are the negotiated price points for qty 25, 50, 75, etc.
  var pricePoints = [100, 170, 220, 240, 300, 320, 350, 380, 390, 400];
  return interpolatePricePoints(qplus, pricePoints);
}
/**
 * calculateLinePrice
 * @returns {number} the line price for booklet wedding programs
 */


function calculateLinePrice(component, numInnerPages) {
  // this calculates the estimated price for deluxe booklet programs
  var qplus = computeRoundedQuantity(component);
  var line_price = 0;

  if (numInnerPages <= 1) {
    line_price = linePriceOnePage(qplus);
  } else if (numInnerPages === 2) {
    line_price = linePriceTwoPages(qplus);
  } else if (numInnerPages >= 3) {
    line_price = linePriceThreePages(qplus);
  }

  return line_price;
}

module.exports = function (accumulator, printJob, product, component) {
  var innerQuantity = parseInt(product.deluxeProgramInteriorPages.quantity, 10);
  var outerQuantity = parseInt(product.deluxeProgramCoverPages.quantity, 10);
  var numInnerPages = Math.round(innerQuantity / outerQuantity);
  var addition = calculateLinePrice(component, numInnerPages);
  return (parseFloat(accumulator, 10) || 0) + addition;
};